import { Box, Chip, Container, Grid, Paper, Tab, Tabs, Typography } from '@mui/material';
import React, { useState } from 'react';
import CalendarView from '../../lib/components/CalendarView';
import { useSchoolStore } from '../../stores/schoolStore';

export const AcademicCalendar: React.FC = () => {
  const { terms, holidays, academicCalendar } = useSchoolStore();
  const [viewMode, setViewMode] = useState<'calendar' | 'list'>('calendar');

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Academic Calendar {academicCalendar.academicYear}
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={viewMode} onChange={(_, newValue) => setViewMode(newValue)}>
          <Tab label="Calendar View" value="calendar" />
          <Tab label="List View" value="list" />
        </Tabs>
      </Box>

      {viewMode === 'calendar' ? (
        <CalendarView terms={terms} holidays={holidays} academicYear={academicCalendar.academicYear} />
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Terms
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                {terms.map((term) => (
                  <Box
                    key={term.id}
                    sx={{
                      p: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      borderRadius: 1,
                    }}
                  >
                    <Typography variant="body1" fontWeight="bold">
                      {term.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {term.startDate} to {term.endDate}
                    </Typography>
                    <Chip label={`${term.weekCount} weeks`} size="small" sx={{ mt: 1 }} />
                  </Box>
                ))}
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Holidays
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
                {holidays
                  .filter((h) => h.type !== 'inset')
                  .map((holiday) => (
                    <Box key={holiday.id}>
                      <Typography variant="body2" fontWeight="medium">
                        {holiday.name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {holiday.startDate} to {holiday.endDate}
                      </Typography>
                    </Box>
                  ))}
              </Box>
            </Paper>

            <Paper sx={{ p: 3, mt: 2 }}>
              <Typography variant="h6" gutterBottom>
                INSET Days
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
                {holidays
                  .filter((h) => h.type === 'inset')
                  .map((inset) => (
                    <Box key={inset.id}>
                      <Typography variant="body2">{inset.name}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        {inset.startDate}
                      </Typography>
                    </Box>
                  ))}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      )}
    </Container>
  );
};

export default AcademicCalendar;
